import React, { useRef } from 'react';
import { customLogger } from '../../helperFunctions';
import SmartLink from '../../components/SmartLink';

const BannerSliderItem = ({ itemData }) => {

    const mouseMoved = useRef(false);

    // handlovanje klika na slajder
    const handleClick = (event) => {
        if (mouseMoved.current) {
            event.preventDefault();
            event.stopPropagation();
            mouseMoved.current = false; // reset nakon drag-a
        }
    };

    customLogger('other', 'item from BannerSliderItem', itemData);

    return (
        <SmartLink
            to={itemData.acBannerLink}
            isNewTabOpen={itemData.isNewTabOpen}
            onMouseMove={() => { mouseMoved.current = true; }}
            onMouseDown={() => { mouseMoved.current = false; }}
            onClick={handleClick}
        >
            <img src={`https://resource.ewe.rs/media/${itemData.acBannerImage}`} className="img-fluid" alt={`${itemData.acSeoDescription}`} title={`${itemData.acSeoTitle}`} />
            {/* <div className="banner-item-block-image" style={{backgroundImage: `url(http://www.ewe.rs/media/${item.acBannerImage})`}}></div> */}
        </SmartLink>
    );
};

export default BannerSliderItem;